export default function EmptyState({ text = "No records found.", action }) {
  return (
    <div className="empty-state">
      <strong>{text}</strong>
      {action ? <div>{action}</div> : null}
    </div>
  );
}